import { Cdr } from '@reliance/types/models/Cdr';
import React from 'react';
import { formatCurrency } from '../format/Currency';

export type CdrTaxActivitySource = {
  cityTaxCollected?: { taxAmount?: number };
  countyTaxCollected?: { taxAmount?: number };
  stateTaxCollected?: { taxAmount?: number };
  specialTaxCollected?: { taxAmount?: number };
  trsTaxCollected?: { taxAmount?: number };
  fusfTaxCollected?: { taxAmount?: number };
  fssfTaxCollected?: { taxAmount?: number };
  subtotal?: number;
  amount?: number;
} | null;

export function getTaxSource(cdr: Cdr): CdrTaxActivitySource {
  const src = cdr.inmateActivity ?? cdr.audioVideoInmateActivity ?? null;
  return src as CdrTaxActivitySource;
}

export const TaxDetailsRow: React.FC<{ cdr: Cdr }> = ({ cdr }) => {
  const source = getTaxSource(cdr);
  const city = source?.cityTaxCollected?.taxAmount ?? 0;
  const county = source?.countyTaxCollected?.taxAmount ?? 0;
  const state = source?.stateTaxCollected?.taxAmount ?? 0;
  const special = source?.specialTaxCollected?.taxAmount ?? 0;
  const fusf = source?.fusfTaxCollected?.taxAmount ?? 0;
  const fssf = source?.fssfTaxCollected?.taxAmount ?? 0;
  const trs = source?.trsTaxCollected?.taxAmount ?? 0;
  const subtotal = source?.subtotal ?? 0;
  const total = source?.amount ?? 0;

  return (
    <div className="tax-info-container" style={{ padding: 10, border: '1px solid #dee2e6', borderRadius: 4, backgroundColor: 'white' }}>
      <h5>Tax Information</h5>
      <div className="row">
        <div className="col-md-6">
          <table className="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Tax Type</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>City Tax</td><td style={{ textAlign: 'right' }}>{formatCurrency(city)}</td></tr>
              <tr><td>County Tax</td><td style={{ textAlign: 'right' }}>{formatCurrency(county)}</td></tr>
              <tr><td>State Tax</td><td style={{ textAlign: 'right' }}>{formatCurrency(state)}</td></tr>
              <tr><td>Special Tax</td><td style={{ textAlign: 'right' }}>{formatCurrency(special)}</td></tr>
              <tr><td>FUSF Charge</td><td style={{ textAlign: 'right' }}>{formatCurrency(fusf)}</td></tr>
              <tr><td>FCC Rate Additive</td><td style={{ textAlign: 'right' }}>{formatCurrency(fssf)}</td></tr>
              <tr><td>TRS Charge</td><td style={{ textAlign: 'right' }}>{formatCurrency(trs)}</td></tr>
            </tbody>
            <tfoot>
              <tr><th>Subtotal</th><th style={{ textAlign: 'right' }}>{formatCurrency(subtotal)}</th></tr>
              <tr><th>Total with Taxes/Charges</th><th style={{ textAlign: 'right' }}>{formatCurrency(total)}</th></tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};
